/* eslint-disable react/jsx-pascal-case */
import * as React from 'react'

import { RadioGroupProps as $RadioGroupProps } from 'antd/lib/radio/interface'
import { Field, FieldProps } from 'formik'

import $Radio, { Props } from '../components/Radio'
import Error from './FormItemError'

export type RadioGroupProps = $RadioGroupProps &
  Props & {
    onRadioChange?: (props: any) => void
    label?: string | React.ReactNode
    placeholder?: string
    size?: 'large' | 'small' | 'middle'
  }

export const Radio = ({ name, onChange, children, ...restProps }: RadioGroupProps) => (
  <Field name={name}>
    {({ field: { value }, form: { setFieldValue, setFieldTouched } }: FieldProps) => (
      <>
        <$Radio
          name={name}
          value={value}
          onChange={(event) => {
            setFieldValue(name, event.target.value)
            setFieldTouched(name, true, false)

            onChange && onChange(event)
          }}
          {...restProps}
        >
          {children}
        </$Radio>
      </>
    )}
  </Field>
)

Radio.Button = ({ name, onChange, children, className, size, ...restProps }: RadioGroupProps) => {
  return (
    <Field name={name}>
      {({ field: { value }, form: { setFieldValue, setFieldTouched } }: FieldProps) => (
        <>
          <$Radio.Button
            name={name}
            className={`${className} t-radio-button`}
            size={size ?? 'large'}
            value={value}
            onChange={(event) => {
              setFieldValue(name, event.target.value)
              setFieldTouched(name, true, false)
              onChange && onChange(event)
            }}
            {...restProps}
          >
            {children}
          </$Radio.Button>
        </>
      )}
    </Field>
  )
}

Radio.ButtonCheckbox = ({ name, onChange, children, className, size, ...restProps }: RadioGroupProps) => {
  return (
    <Field name={name}>
      {({ field: { value }, form: { setFieldValue, setFieldTouched } }: FieldProps) => (
        <>
          <$Radio.Button
            name={name}
            className={className}
            size={size ?? 'large'}
            value={value}
            onChange={(event) => {
              setFieldValue(name, event.target.value)
              setFieldTouched(name, true, false)
              onChange && onChange(event)
            }}
            {...restProps}
          >
            {children}
          </$Radio.Button>
        </>
      )}
    </Field>
  )
}

Radio.Group = ({ name, onChange, onRadioChange, className, ...restProps }: RadioGroupProps) => (
  <Field name={name}>
    {({ field: { value }, form: { setFieldValue, setFieldTouched }, meta: { error, touched } }: FieldProps) => (
      <>
        <$Radio.Group
          name={name}
          className={`w-100 ${className}`}
          value={value}
          onChange={(event) => {
            setFieldValue(name, event.target.value)
            setFieldTouched(name, true, false)
            onRadioChange && onRadioChange(event)
            onChange && onChange(event)
          }}
          {...restProps}
        />
        {error && touched && value === null && <Error children={error} />}
      </>
    )}
  </Field>
)

export default Radio
